<script lang="ts">
	// Bridges the mobile sidebar drawer to the rest of the app. Must be mounted
	// as a descendant of <Sidebar.Provider>, since useSidebar() reads from
	// context.
	//  - Opens the drawer on a window-level `sayano:open-sidebar` CustomEvent
	//    (the layout's edge-swipe dispatches it).
	//  - Closes the drawer after every route navigation (SAY-1822): tapping a
	//    chat, a folder chip or a nav link should reveal the page, not leave the
	//    drawer covering it. The desktop sidebar is untouched — openMobile is
	//    only read by the <md Sheet.
	import { afterNavigate } from '$app/navigation';
	import { useSidebar } from '$lib/components/ui/sidebar/index.js';

	const sidebar = useSidebar();

	$effect(() => {
		if (typeof window === 'undefined') return;
		const onOpen = () => sidebar.setOpenMobile(true);
		window.addEventListener('sayano:open-sidebar', onOpen);
		return () => window.removeEventListener('sayano:open-sidebar', onOpen);
	});

	afterNavigate(({ type }) => {
		if (type === 'enter') return;
		if (sidebar.openMobile) sidebar.setOpenMobile(false);
	});
</script>
